export const SET_USER_ROLES = 'SET_USER_ROLES';
export const SET_NEW_TOKEN = 'SET_NEW_TOKEN';
export const SET_USER_STATUS = 'SET_USER_STATUS';